import {Component, OnInit} from '@angular/core';

import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';

import { UtilityService } from './core/utility/utility.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
    year : number;
spinnerCount = 0;

_loading: boolean;

startSpinner = function(){
 if(this.spinnerCount == 0)
   this._loading = true;

   this.spinnerCount++;
}

stopSpinner = function(){
 this.spinnerCount--;

 if(this.spinnerCount == 0)
   this._loading = false;
}

set loading(b: boolean)
{
  switch(b){
    case true:
     this.startSpinner(); 
    break;

    default:
     this.stopSpinner();
  } 
 }

 // Shows and hides the loading spinner during RouterEvent changes
 navigationInterceptor(event: RouterEvent): void {
   if (event instanceof NavigationStart) {
     this.loading = true
   }
   if (event instanceof NavigationEnd) {
     this.loading = false
   }

   // Set loading state to false in both of the below events to hide the spinner in case a request fails
   if (event instanceof NavigationCancel) {
     this.loading = false
   }
   if (event instanceof NavigationError) {
     this.loading = false
   }
 }
 
constructor( 
     private router: Router,
     private utilityService: UtilityService
   ) 
   {
     router.events.subscribe((event: RouterEvent) => {
       this.navigationInterceptor(event)
     })

     utilityService.loadingChangeEmitted$.subscribe(
       boolean => {
           this.loading = boolean;
       }
     )
   }

    ngOnInit(): void {
        this.year = new Date().getFullYear();
        // throw new Error('Method not implemented.');
    }
}

